var radius = 25;

var test = document.createElement('script');
test.type = 'text/javascript';

// test.src = 'https://demo.convergepay.com/hosted-payments/PayWithConverge.js';
test.src = 'https://api.demo.convergepay.com/hosted-payments/Checkout.js';       //Test Link
//  test.src = 'https://api.convergepay.com/hosted-payments/transaction_token';      //Checkout script prod
//  test.src = 'https://api.convergepay.com/hosted-payments/Checkout.js';      //Checkout script prod
document.body.appendChild(test);
var test1 = document.createElement('script');
test1.type = 'text/javascript';

// test.src = 'https://demo.convergepay.com/hosted-payments/PayWithConverge.js';
 test1.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js';
 

document.body.appendChild(test1);

function calculateRadius(pi) {
    let piValue = 3.14159;

    if(pi) {
        piValue = pi;
    }

    var result = piValue * radius * radius;
    console.log('Result: ', result);
}

 function wrapperMethods(pi) {
    console.log('Hi, this is from wrapper method');
    calculateRadius(pi)
}

function openLightbox(test) {
    var paymentFields = {
        ssl_txn_auth_token: test
    };
    var callback = {
        onError: function (error) {
            showResult("error", error);
        },
        onCancelled: function () {
            showResult("cancelled", "");
        },
        onDeclined: function (response) {
            showResult("declined", JSON.stringify(response, null, '\t'));
            window.location.href = 'https://thzretail.com/TL-Get-Quote/#/failure-payment';
            localStorage.setItem('transactionID',response.ssl_txn_id);
            // localStorage.setItem('firstName',response.ssl_first_name);
            // localStorage.setItem('lastName',response.ssl_last_name);
            localStorage.setItem('amount',ssl_amount);
            localStorage.setItem('ssl_merchant_initiated_unscheduled',response.ssl_merchant_initiated_unscheduled);
            localStorage.setItem('ssl_issuer_response',response.ssl_issuer_response);
            localStorage.setItem('ssl_partner_app_id',response.ssl_partner_app_id);
            localStorage.setItem('ssl_card_number',response.ssl_card_number);
            localStorage.setItem('ssl_transaction_type',response.ssl_transaction_type);
            localStorage.setItem('ssl_transaction_reference_number',response.ssl_transaction_reference_number);
            localStorage.setItem('ssl_result',response.ssl_result);
            localStorage.setItem('ssl_approval_code',response.ssl_approval_code);
            localStorage.setItem('ssl_txn_time',response.ssl_txn_time);
            localStorage.setItem('ssl_amount',response.ssl_amount);
            localStorage.setItem('ssl_transaction_currency',response.ssl_transaction_currency);
            localStorage.setItem('ssl_account_balance',response.ssl_account_balance);
            localStorage.setItem('ssl_ps2000_data',response.ssl_ps2000_data);
            localStorage.setItem('ssl_exp_date',response.ssl_exp_date);
            localStorage.setItem('ssl_result_message',response.ssl_result_message);
            localStorage.setItem('ssl_card_short_description',response.ssl_card_short_description);
            localStorage.setItem('ssl_get_token',response.ssl_get_token);
            localStorage.setItem('ssl_token_response',response.ssl_token_response);
            localStorage.setItem('ssl_card_type',response.ssl_card_type);
            localStorage.setItem('ssl_cvv2_response',response.ssl_cvv2_response);
        },
        onApproval: function (response) {
            showResult("approval", JSON.stringify(response, null, '\t'));
            window.location.href = 'https://thzretail.com/TL-Get-Quote/#/payments';
            localStorage.setItem('transactionID',response.ssl_txn_id);
            // localStorage.setItem('firstName',response.ssl_first_name);
            // localStorage.setItem('lastName',response.ssl_last_name);
            localStorage.setItem('amount',response.ssl_amount);
            localStorage.setItem('ssl_merchant_initiated_unscheduled',response.ssl_merchant_initiated_unscheduled);
            localStorage.setItem('ssl_issuer_response',response.ssl_issuer_response);
            localStorage.setItem('ssl_partner_app_id',response.ssl_partner_app_id);
            localStorage.setItem('ssl_card_number',response.ssl_card_number);
            localStorage.setItem('ssl_transaction_type',response.ssl_transaction_type);
            localStorage.setItem('ssl_transaction_reference_number',response.ssl_transaction_reference_number);
            localStorage.setItem('ssl_result',response.ssl_result);
            localStorage.setItem('ssl_approval_code',response.ssl_approval_code);
            localStorage.setItem('ssl_txn_time',response.ssl_txn_time);
            localStorage.setItem('ssl_amount',response.ssl_amount);
            localStorage.setItem('ssl_transaction_currency',response.ssl_transaction_currency);
            localStorage.setItem('ssl_account_balance',response.ssl_account_balance);
            localStorage.setItem('ssl_ps2000_data',response.ssl_ps2000_data);
            localStorage.setItem('ssl_exp_date',response.ssl_exp_date);
            localStorage.setItem('ssl_result_message',response.ssl_result_message);
            localStorage.setItem('ssl_card_short_description',response.ssl_card_short_description);
            localStorage.setItem('ssl_get_token',response.ssl_get_token);
            localStorage.setItem('ssl_token_response',response.ssl_token_response);
            localStorage.setItem('ssl_card_type',response.ssl_card_type);
            localStorage.setItem('ssl_cvv2_response',response.ssl_cvv2_response);
        }
    };
    PayWithConverge.open(paymentFields, callback);
    return false;
}

function pay(test,cardNo,expDate,firstName,lastName,sslavsaddress,sslavszip) {
    var paymentData = {
        ssl_txn_auth_token: test,
        // ssl_card_number: cardNo,
        ssl_token: cardNo,
        ssl_exp_date: expDate,
        ssl_get_token: 'y',
        ssl_add_token: 'y',
        ssl_first_name: firstName,
        ssl_last_name: lastName,
        // ssl_cvv2cvc2: cvv,
        ssl_merchant_txn_id: "MerchantTXNIDHere",
        ssl_avs_address: sslavsaddress,
        ssl_avs_zip: sslavszip
    };
    var callback = {
        onError: function (error) {
            showResult("error", error);
        },
        onDeclined: function (response) {
            localStorage.removeItem('responseID');
            localStorage.removeItem('ssl_first_name');
            localStorage.removeItem('transactionID');
            localStorage.removeItem('ssl_last_name');
            localStorage.removeItem('amount');
            localStorage.removeItem('ssl_merchant_initiated_unscheduled');
            localStorage.removeItem('ssl_issuer_response');
            localStorage.removeItem('ssl_partner_app_id');
            localStorage.removeItem('ssl_card_number');
            localStorage.removeItem('ssl_transaction_type');
            localStorage.removeItem('ssl_transaction_reference_number');
            localStorage.removeItem('ssl_result');
            localStorage.removeItem('ssl_approval_code');
            localStorage.removeItem('ssl_txn_time');
            localStorage.removeItem('ssl_amount');
            localStorage.removeItem('ssl_transaction_currency');
            localStorage.removeItem('ssl_account_balance');
            localStorage.removeItem('ssl_ps2000_data');
            localStorage.removeItem('ssl_exp_date');
            localStorage.removeItem('ssl_result_message');
            localStorage.removeItem('ssl_card_short_description');
            localStorage.removeItem('ssl_get_token');
            localStorage.removeItem('ssl_token_response');
            localStorage.removeItem('ssl_card_type');
            localStorage.removeItem('ssl_cvv2_response');
            localStorage.removeItem('ssl_add_token_response');
            localStorage.removeItem('ssl_avs_response');
            localStorage.removeItem('ssl_first_name');
            localStorage.removeItem('ssl_last_name');
            localStorage.removeItem('ssl_oar_data');
            localStorage.removeItem('ssl_get_token');
            localStorage.removeItem('ssl_salestax');
            localStorage.removeItem('ssl_token');
            localStorage.removeItem('ssl_avs_address');
            localStorage.removeItem('ssl_avs_zip');
            if(response.errorName!==undefined){
                localStorage.setItem('responseID',response.errorName);
            }
            localStorage.setItem('ssl_result_message',response.ssl_result_message);
             
            localStorage.setItem('transactionID',response.ssl_txn_id);
            localStorage.setItem('ssl_first_name',response.ssl_first_name);
            localStorage.setItem('ssl_last_name',response.ssl_last_name);
            localStorage.setItem('amount',ssl_amount);
            localStorage.setItem('ssl_merchant_initiated_unscheduled',response.ssl_merchant_initiated_unscheduled);
            localStorage.setItem('ssl_issuer_response',response.ssl_issuer_response);
            localStorage.setItem('ssl_partner_app_id',response.ssl_partner_app_id);
            localStorage.setItem('ssl_card_number',response.ssl_card_number);
            localStorage.setItem('ssl_transaction_type',response.ssl_transaction_type);
            localStorage.setItem('ssl_transaction_reference_number',response.ssl_transaction_reference_number);
            localStorage.setItem('ssl_result',response.ssl_result);
            localStorage.setItem('ssl_approval_code',response.ssl_approval_code);
            localStorage.setItem('ssl_txn_time',response.ssl_txn_time);
            localStorage.setItem('ssl_amount',response.ssl_amount);
            localStorage.setItem('ssl_transaction_currency',response.ssl_transaction_currency);
            localStorage.setItem('ssl_account_balance',response.ssl_account_balance);
            localStorage.setItem('ssl_ps2000_data',response.ssl_ps2000_data);
            localStorage.setItem('ssl_exp_date',response.ssl_exp_date);
            localStorage.setItem('ssl_result_message',response.ssl_result_message);
            localStorage.setItem('ssl_card_short_description',response.ssl_card_short_description);
            localStorage.setItem('ssl_get_token',response.ssl_get_token);
            localStorage.setItem('ssl_token_response',response.ssl_token_response);
            localStorage.setItem('ssl_card_type',response.ssl_card_type);
            localStorage.setItem('ssl_cvv2_response',response.ssl_cvv2_response);
            localStorage.setItem('ssl_add_token_response',response.ssl_add_token_response);
            localStorage.setItem('ssl_avs_response',response.ssl_avs_response);
            localStorage.setItem('ssl_first_name',response.ssl_first_name);
            localStorage.setItem('ssl_last_name',response.ssl_last_name);
            localStorage.setItem('ssl_oar_data',response.ssl_oar_data);
            localStorage.setItem('ssl_get_token',response.ssl_get_token);
            localStorage.setItem('ssl_salestax',response.ssl_salestax);
            localStorage.setItem('ssl_token',response.ssl_token);
            localStorage.setItem('ssl_avs_address',response.ssl_avs_address);
            localStorage.setItem('ssl_avs_zip',response.ssl_avs_zip);
        //    window.location.href = 'https://thzretail.com/TL-Broker-Self-Help-Portal/#/dashboard/payment';
            //  window.location.href = 'http://localhost:4200/#/dashboard/payment';
        },
        onApproval: function (response) {
            localStorage.removeItem('responseID');
            localStorage.removeItem('ssl_first_name');
            localStorage.removeItem('transactionID');
            localStorage.removeItem('ssl_last_name');
            localStorage.removeItem('amount');
            localStorage.removeItem('ssl_merchant_initiated_unscheduled');
            localStorage.removeItem('ssl_issuer_response');
            localStorage.removeItem('ssl_partner_app_id');
            localStorage.removeItem('ssl_card_number');
            localStorage.removeItem('ssl_transaction_type');
            localStorage.removeItem('ssl_transaction_reference_number');
            localStorage.removeItem('ssl_result');
            localStorage.removeItem('ssl_approval_code');
            localStorage.removeItem('ssl_txn_time');
            localStorage.removeItem('ssl_amount');
            localStorage.removeItem('ssl_transaction_currency');
            localStorage.removeItem('ssl_account_balance');
            localStorage.removeItem('ssl_ps2000_data');
            localStorage.removeItem('ssl_exp_date');
            localStorage.removeItem('ssl_result_message');
            localStorage.removeItem('ssl_card_short_description');
            localStorage.removeItem('ssl_get_token');
            localStorage.removeItem('ssl_token_response');
            localStorage.removeItem('ssl_card_type');
            localStorage.removeItem('ssl_cvv2_response');
            localStorage.removeItem('ssl_add_token_response');
            localStorage.removeItem('ssl_avs_response');
            localStorage.removeItem('ssl_first_name');
            localStorage.removeItem('ssl_last_name');
            localStorage.removeItem('ssl_oar_data');
            localStorage.removeItem('ssl_get_token');
            localStorage.removeItem('ssl_salestax');
            localStorage.removeItem('ssl_token');
            localStorage.removeItem('ssl_avs_address');
            localStorage.removeItem('ssl_avs_zip');
            localStorage.setItem('transactionID',response.ssl_txn_id);
            localStorage.setItem('ssl_first_name',response.ssl_first_name);
            localStorage.setItem('ssl_last_name',response.ssl_last_name);
            localStorage.setItem('amount',response.ssl_amount);
            localStorage.setItem('ssl_merchant_initiated_unscheduled',response.ssl_merchant_initiated_unscheduled);
            localStorage.setItem('ssl_issuer_response',response.ssl_issuer_response);
            localStorage.setItem('ssl_partner_app_id',response.ssl_partner_app_id);
            localStorage.setItem('ssl_card_number',response.ssl_card_number);
            localStorage.setItem('ssl_transaction_type',response.ssl_transaction_type);
            localStorage.setItem('ssl_transaction_reference_number',response.ssl_transaction_reference_number);
            localStorage.setItem('ssl_result',response.ssl_result);
            localStorage.setItem('ssl_approval_code',response.ssl_approval_code);
            localStorage.setItem('ssl_txn_time',response.ssl_txn_time);
            localStorage.setItem('ssl_amount',response.ssl_amount);
            localStorage.setItem('ssl_transaction_currency',response.ssl_transaction_currency);
            localStorage.setItem('ssl_account_balance',response.ssl_account_balance);
            localStorage.setItem('ssl_ps2000_data',response.ssl_ps2000_data);
            localStorage.setItem('ssl_exp_date',response.ssl_exp_date);
            localStorage.setItem('ssl_result_message',response.ssl_result_message);
            localStorage.setItem('ssl_card_short_description',response.ssl_card_short_description);
            localStorage.setItem('ssl_get_token',response.ssl_get_token);
            localStorage.setItem('ssl_token_response',response.ssl_token_response);
            localStorage.setItem('ssl_card_type',response.ssl_card_type);
            localStorage.setItem('ssl_cvv2_response',response.ssl_cvv2_response);
            localStorage.setItem('ssl_token',response.ssl_token);
            localStorage.setItem('ssl_add_token_response',response.ssl_add_token_response);
            localStorage.setItem('ssl_salestax',response.ssl_salestax);
            localStorage.setItem('ssl_oar_data',response.ssl_oar_data);
            localStorage.setItem('ssl_avs_address',response.ssl_avs_address);
            localStorage.setItem('ssl_avs_zip',response.ssl_avs_zip);
            //  window.location.href = 'https://thzretail.com/TL-Broker-Self-Help-Portal/#/dashboard/payment';
            //   window.location.href = 'http://localhost:4200/#/dashboard/payment';
        }
    };
    ConvergeEmbeddedPayment.pay(paymentData, callback);
    return false;
}


function showResult(status, msg) {
    // document.getElementById('txn_status').innerHTML = "<b>" + status + "</b>";
    // document.getElementById('txn_response').innerHTML = msg;
    console.log(status);
    console.log(msg)
}
